import React from "react";

interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  text?: string;
  light?: boolean;
  center?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  eyebrow,
  title,
  text,
  light = false,
  center = true,
}) => (
  <div
    className={`dm-section-header${light ? " dm-section-header--light" : ""}${
      center ? " dm-section-header--center" : ""
    }`}
  >
    <span>{eyebrow}</span>
    <h2>{title}</h2>
    {text && <p>{text}</p>}
  </div>
);

export default SectionHeader;
